import { TrustPilotLogo } from '@/components/TrustPilot/TrustPilotLogo';
import { TrustPilotRating } from '@/components/TrustPilot/TrustPilotRating';
import { TrustScoreAndReviews } from '@/components/TrustPilot/TrustScoreAndReviews';
import type { TrustPilotImageProps } from '@/components/TrustPilot/types';
export const TrustPilotImage = ({
  stars,
  trustScore,
  totalReviews
}: TrustPilotImageProps) => <div className="flex flex-col justify-start gap-2.5 md:flex-row md:items-center md:gap-4" data-sentry-component="TrustPilotImage" data-sentry-source-file="TrustPilotImage.tsx">
    <div className="flex justify-start md:order-last">
      <TrustPilotLogo className="h-7 md:h-6 2xl:h-7" data-sentry-element="TrustPilotLogo" data-sentry-source-file="TrustPilotImage.tsx" />
    </div>
    <div className="hidden flex-row gap-1 font-sans text-gray-950 text-sm md:flex 2xl:text-base dark:text-white">
      Check out our{' '}
      <span className="font-semibold">
        {new Intl.NumberFormat().format(totalReviews ?? 1573)} reviews
      </span>
    </div>
    <TrustPilotRating stars={stars} data-sentry-element="TrustPilotRating" data-sentry-source-file="TrustPilotImage.tsx" />
    <div className="md:hidden">
      <TrustScoreAndReviews totalReviews={totalReviews} trustScore={trustScore} data-sentry-element="TrustScoreAndReviews" data-sentry-source-file="TrustPilotImage.tsx" />
    </div>
  </div>;